import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display } from '../../utils/configuredReportFormatters'

export const w9Columns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'company_name',
    label: 'Company',
    sortKey: 'company_name',
    render: (row) => display(row.company_name),
  },
  {
    id: 'property_name',
    label: 'Property',
    sortKey: 'property_name',
    render: (row) => display(row.property_name),
  },
  {
    id: 'fedral_number',
    label: 'Federal Number',
    sortKey: 'federal_id',
    render: (row) =>
      display(row.federal_id ?? row.fedral_number ?? row.federal_number),
  },
  {
    id: 'uploaded',
    label: 'Uploaded W9',
    sortKey: 'uploaded',
    render: (row) =>
      String(row.uploaded ?? row.w9_uploaded ?? '') === '1' ? 'Yes' : 'No',
  },
]
